(function(w) {
    w.Kinougarde = Object.assign({},w.Kinougarde);

    // Check if input has focus to maintain the label outside
    w.Kinougarde.checkFocus = function(input) {
        var customClass = 'input-custom-value'
    
        if (input.value) input.classList.add(customClass)
        else input.classList.remove(customClass)
    }

    /**
     * 
     * Initialisation des composants HTML 
     */
    w.Kinougarde.InitHtmlComponant = function (element= document) {
                
        // Initialise les labels flotant autour des input         
        var $inputCustom = element.querySelectorAll('.js-input-custom')
        if ($inputCustom) {
            Array.prototype.forEach.call($inputCustom, function(element, index){
                w.Kinougarde.checkFocus(element)
                element.addEventListener('blur', function(event){
                    w.Kinougarde.checkFocus(this)
                })
            })
        }
    }

    jQuery(function() {      
        // Initialise le composant Html             
        w.Kinougarde.InitHtmlComponant();                
    })

})(window);



function setRadio() {
    var $togglers = document.querySelectorAll('.js-accordions .accordion-toggler')

    Array.prototype.forEach.call($togglers, function(element, index){
        var $input = document.getElementById(element.getAttribute('for'))
        $input.setAttribute('type', 'radio')
    })
}

function setCheckbox() {
    var $togglers = document.querySelectorAll('.js-accordions .accordion-toggler')

    Array.prototype.forEach.call($togglers, function(element, index){
        var $input = document.getElementById(element.getAttribute('for'))
        $input.setAttribute('type', 'checkbox')
    })
}

var $accordionsTabs = document.querySelectorAll('.js-accordions')
if($accordionsTabs) {
    Array.prototype.forEach.call($accordionsTabs, function(element, index){

        if (window.matchMedia("(max-width:739px)").matches) {
            setCheckbox()
        } else {
            setRadio()
        }

        window.addEventListener('resize', function(){
            if (window.matchMedia("(max-width:739px)").matches) {
                setCheckbox()
            } else {
                setRadio()

                if (!(element.querySelectorAll('input:checked').length)) {
                    element.querySelectorAll('input')[0].checked = true
                }
            }
        })

        var $tabContent = element.querySelectorAll('[name="tabs"]')
        if ($tabContent) {
            Array.prototype.forEach.call($tabContent, function(element, index){
                element.addEventListener('change', function() {
                    var element = this
                    var map = element.parentNode.querySelectorAll('.js-google-maps')
                    if (map) {
                        Array.prototype.forEach.call(map, function(el, i) {
                            var mapID = '#' + el.id,
                                $maps = (mapID in window.kinougardeMaps.maps) ? window.kinougardeMaps.maps[mapID] : false;

                            var center = $maps.map.getCenter()
                            google.maps.event.trigger($maps.map, 'resize')
                            $maps.map.setCenter(center)
                            $maps.map.setZoom(15)
                        })
                    }
                })
            });
        }
    })
}

// Article Accordeon Toggler
$(document.body).on('click', '.js-accordion-toggler', function (e) {
    e.preventDefault()
    var $accordion = $(this).closest('.js-accordion')
    var $accordions = $accordion.closest('.js-accordions')
    var toggleClass = 'toggled'

    if ($accordions.length) {
        $accordions = $accordions.get(0).querySelectorAll('.js-accordion')

        if (document.documentElement.clientWidth > 740) {
            $accordions.classList.remove(toggleClass)
        }
    }

    $accordion.get(0).classList.toggle(toggleClass)

    if ($accordion.parents('.js-owl-carousel').length > 0) setTimeout( function () { autoHeightSlider($accordion.parents('.js-owl-carousel')) }, 200)
})

// Card with map Toggler
// var map_toggle_links = document.querySelectorAll('.toggle-link')
// if (map_toggle_links) {
//     Array.prototype.forEach.call(map_toggle_links, function(element, index){
//         element.addEventListener('click', function(event){
//             this.parentNode.nextElementSibling.classList.toggle('open')
//         })
//     });
// }



// // Find an agency
// var $departmentSelect = document.getElementById('department')
// if ($departmentSelect) {
//     $departmentSelect.addEventListener('change', function(event) {
//         window.location = this.value
//     })
// }



// // Disabled Elements
// var $disabledElements = document.querySelectorAll('[disabled]')
// if ($disabledElements) {
//     Array.prototype.forEach.call($disabledElements, function(element, index) {
//         element.addEventListener('click', function(event) {
//             event.preventDefault()
//             event.stopPropagation()
//             return false
//         })
//     })
// }

// var $disableSiblings = $('.js-disable-siblings')
// var $siblings = $disableSiblings.parent().siblings().find('input').not('.js-disable-siblings')
// $disableSiblings.on('change', function () {
//     if ($(this).is(':checked')) $siblings.attr('checked', false)
// })

// $siblings.on('change', function(){
//     if ($(this).is(':checked')) $disableSiblings.attr('checked', false)
// })

var checkedRadio = {}
$.each( $('.js-radio-toggle'), function () {
    var name = $(this).attr('name')
    var val = $(this).val()
    if ($(this).is(':checked')) checkedRadio[name] = val
})
$('.js-radio-toggle').click( function () {
    var name = $(this).attr('name')
    var val = $(this).val()
    if ( typeof checkedRadio[name] !== "undefined" && checkedRadio[name] == val ) {
        $(this).attr('checked', false).change()
        delete checkedRadio[name]
    } else {
        checkedRadio[name] = val
    }
})
